import React, { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const IconUndo = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 24 24"
      data-fill-none
    >
      <path
        d="M6.90234 6.90137V10.2998H10.3008"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 17.0967C12.9347 17.0972 13.8516 16.8408 14.6503 16.3554C15.4491 15.87 16.099 15.1743 16.5291 14.3444C16.9591 13.5145 17.1527 12.5824 17.0887 11.6499C17.0247 10.7174 16.7055 9.82044 16.1661 9.05711C15.6267 8.29378 14.8878 7.69346 14.0302 7.32176C13.1726 6.95007 12.2293 6.82133 11.3034 6.9496C10.3776 7.07788 9.50481 7.45824 8.78056 8.0491C8.05632 8.63996 7.50846 9.41857 7.1969 10.2998"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  ))
);

IconUndo.displayName = 'IconUndo';
